import { z } from 'zod';
import { englishIqResponseV2Schema } from '../schemasV2';

export const answerEnglishIqV2RequestSchema = z.object({
  idempotencyId: z.string().min(1).max(128),
  itemId: z.string().min(1).max(128),
  replayCount: z.number().int().min(0).max(2),
  response: englishIqResponseV2Schema,
  responseTimeMs: z.number().int().min(0).max(1_800_000),
  token: z.string().min(1),
});

export type IAnswerEnglishIqV2Request = z.infer<typeof answerEnglishIqV2RequestSchema>;
